<template>
    <div class="mdc-dialog">
        <div class="mdc-dialog__container">
            <div class="mdc-dialog__surface">
            <h2 class="mdc-dialog__title mdc-typography--headline7" v-if="!!alertTitle">{{alertTitle}}</h2>
            <div class="mdc-dialog__content mdc-typography--body1 text-contents" id="my-dialog-content" v-html="alertContent">
                
            </div>
            <footer class="mdc-dialog__actions">
                
                <button type="button" class="mdc-button mdc-dialog__button btn-white" data-mdc-dialog-action="close" @click.prevent="onCancel" v-show="!!alertCancel && isConfirm" tabindex="-1">{{alertCancel}}</button>
                <button type="button" class="mdc-button mdc-dialog__button btn-white" data-mdc-dialog-action="accept" data-mdc-dialog-initial-focus @click.prevent="onAccept" v-show="!!alertAccept" tabindex="1">{{alertAccept}}</button>
            </footer>
            </div>
        </div>
        <div class="mdc-dialog__scrim"></div>
    </div>
</template>

<script>
/**
 * alert/confirm component
 *
 * @author minkyoung.park@emcast.com
 */
import {MDCDialog} from '@material/dialog'
export default {
    data() {
        return {
            dialog: null,
            alertTitle: '',
            alertContent: '',
            alertCancel: 'cancel',
            alertAccept: 'confirm',
            resolved: null,
            rejected: null,
            isConfirm: false,
            acceptStatus: false,

        }
    },
    
    methods: {
        // 
        attachMaterial(el) {
            this.dialog = MDCDialog.attachTo(el)            
        },

        open(payload, isConfirm){
            // console.log('payload', payload)
            console.log('this.dialog', this.dialog);
            
            return new Promise((resolve, reject) => {
                this.dialog.autoStackButtons = false
                this.alertTitle = payload.title
                this.alertContent = payload.content
                this.isConfirm = isConfirm
                this.resolved = resolve
                this.rejected = reject
                
                if (payload.accept) {
                    this.alertAccept = payload.accept
                }else {
                    this.alertAccept = 'confirm'
                }

                if (payload.cancel) {
                    this.alertCancel = payload.cancel
                }else {
                    this.alertCancel = 'cancel'
                }

                this.dialog.open()
            })
        },

        close() {
            this.dialog.listen('MDCDialog:closed', () => {
                // console.log('alert closed')
                if (this.acceptStatus === true) {
                    this.resolved(true)
                }else {
                    this.rejected(true)
                }
            })
            this.dialog.close()
        },
        onAccept() {
            this.acceptStatus = true
            this.close()
        },
        onCancel() {
            this.acceptStatus = false
            this.close()
        }
    }
}
</script>
